import { useState } from 'react'
import './KPI.css'
import KpiData from './KpiData/KpiData'


const KPI = () => {

    //All other states
    const [isOpen, setIsOpen] = useState(localStorage.getItem("kpi_home_open") === "true")

    const handleKpiOpen = (isChecked) => {
        setIsOpen(isChecked)
        localStorage.setItem(`kpi_home_open`, isChecked)
    }


    return (
        <div className='home_kpi_main'>
            <div className='home_kpi_toggle'>
                <p>Voir les KPIs AGO</p>
                <label className="toggle">
                    <input className="toggle-checkbox"
                        type="checkbox"
                        checked={isOpen}
                        onChange={(e) => handleKpiOpen(e.target.checked)}
                    />
                    <div className="toggle-switch"></div>
                </label>
            </div>

            <div className={`home_kpi_lists ${isOpen ? "home_kpi_lists_transition" : ""}`}>
                {isOpen && (
                    <div className='home_kpi_item'>
                        <KpiData />
                    </div>
                )}
            </div>
        </div>

    )
}

export default KPI